// ======================================================================
// File Name       : multiLanguage
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../../constants/actionTypes/content';

export function receiveTranslateResponse(translateSuccess) {
  return {
    type: ActionTypes.MULTI_LANGUAGE_RECEIVE_TRANSLATE_RESPONSE,
    translateSuccess,
  };
}

export function receiveLanguageConfirmInfo(multiLanguageConfirmInfo) {
  return {
    type: ActionTypes.MULTI_LANGUAGE_RECEIVE_CONFIRM_INFO,
    multiLanguageConfirmInfo,
  };
}

export function editLanguageInfo(editSuccess) {
  return {
    type: ActionTypes.MULTI_LANGUAGE_EDIT_LANGUAGE_INFO,
    editSuccess,
  };
}

export function refreshLanguageInfo(isRefreshData) {
  return {
    type: ActionTypes.MULTI_LANGUAGE_REFRESH_LANGUAGE_INFO,
    isRefreshData,
  };
}

export function deleteLanguageInfo(resData) {
  return {
    type: ActionTypes.MULTI_LANGUAGE_DELETE_LANGUAGE_INFO,
    resData,
  };
}

export function resetMultiLanguageInfo() {
  return {
    type: ActionTypes.MULTI_LANGUAGE_RESET_INFO,
  };
}

export function resetMultiLanguageStatus() {
  return {
    type: ActionTypes.MULTI_LANGUAGE_RESET_STATUS,
  };
}

export function saveMultiLanguageCode(languageCode) {
  return {
    type: ActionTypes.MULTI_LANGUAGE_SAVE_LANGUAGE_CODE,
    languageCode,
  };
}

export function postGetMultiLanguageProcessResultList(resData) {
  return {
    type: ActionTypes.GET_MULTI_LANGUAGE_PROCESS_RESULT_LIST,
    resData,
  };
}

export function postGetMultiLanguageProcessDetail(resData) {
  return {
    type: ActionTypes.GET_MULTI_LANGUAGE_PROCESS_DETAIL,
    resData,
  };
}
